<template>
  <div
    id="pum-18322"
    role="dialog"
    aria-hidden="false"
    class="pum pum-overlay pum-theme-16727 pum-theme-lightbox popmake-overlay click_open pum-active"
    style="opacity: 1; display: block;"
  >
    <div
      id="modal-quickorder"
      class="pum-container popmake theme-16727 pum-responsive pum-responsive-medium responsive size-medium active custom-position"
    >
      <div class="pum-content popmake-content">
        <div
          class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
        >
          <div class="seasidetms_row_outer_parent">
            <div class="seasidetms_row_outer">
              <div class="seasidetms_row_inner">
                <div class="seasidetms_row_margin seasidetms_11">
                  <div class="seasidetms_column one_first">
                    <div class="seasidetms_column_inner">
                      <div class="seasidetms_contact_form">
                        <div
                          role="form"
                          class="wpcf7"
                          id="wpcf7-f16732-o1"
                          lang="ru-RU"
                          dir="ltr"
                        >
                          <div class="screen-reader-response"></div>
                          <form
                            class="wpcf7-form"
                            novalidate="novalidate"
                            @sumbit.prevent
                          >
                            <div style="max-width: 300px; margin: auto">
                              <span
                                style="display: inline-block;text-align: center"
                              >
                                {{ $t('fillFormContact') }}
                              </span>
                              <br />
                              <span class="wpcf7-form-control-wrap text-544">
                                <input
                                  type="text"
                                  name="name"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                  :placeholder="$t('yourName')"
                                  v-model="name"
                                  @blur="$v.name.$touch()"
                                />
                                <div
                                  class="error"
                                  v-if="$v.name.$dirty && !$v.name.required"
                                >
                                  {{ $t('appealForm.emptyName') }}
                                </div>
                              </span>
                              <br />
                              <span class="wpcf7-form-control-wrap tel-958">
                                <input
                                  type="tel"
                                  name="phone"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel tel-958"
                                  :placeholder="$t('yourPhone')"
                                  maxlength="19"
                                  @input="phoneMask()"
                                  v-model="phone"
                                  @blur="$v.phone.$touch()"
                                />
                                <div
                                  class="error"
                                  v-if="$v.phone.$dirty && !$v.phone.required"
                                >
                                  {{ $t('appealForm.emptyPhone') }}
                                </div>
                                <div
                                  class="error"
                                  v-if="$v.phone.$dirty && !$v.phone.alpha"
                                >
                                  {{ $t('appealForm.invalidPhone') }}
                                </div>
                              </span>
                              <span
                                class="wpcf7-form-control-wrap dynamichidden-463"
                              >
                              </span>
                              <span class="product-oneclick">
                                <b>{{ $t('product') }}:</b> {{ productName }}
                              </span>
                              <p></p>
                              <p v-if="!sent">
                                <input
                                  type="submit"
                                  :value="$t('send')"
                                  class="wpcf7-form-control wpcf7-submit btn-send"
                                  @click.stop.prevent="onSubmit"
                                />
                                <span class="ajax-loader"></span>
                              </p>
                              <div class="success-msg" v-else>
                                <p>{{ $t('appealForm.formSent') }}</p>
                              </div>
                            </div>
                            <div
                              class="wpcf7-response-output wpcf7-display-none"
                            ></div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p></p>
      </div>
      <button type="button" class="pum-close popmake-close" @click="onClose">
        X
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'

export default {
  name: 'QuickOrderModal',
  data() {
    return {
      name: '',
      phone: '',
      sent: false,
    }
  },
  computed: {
    productName() {
      const product = this.$store.state.productModal
      return product[`name_${this.$i18n.locale}`]
        ? product[`name_${this.$i18n.locale}`]
        : product.name
        ? product.name
        : ''
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        this.submitQuickOrder({
          name: this.name,
          phone: this.phone,
          product: this.$store.state.product._id,
        }).then(() => {
          this.$v.$reset()
          this.sent = true
          this.name = ''
          this.phone = ''
          // this.setQuickOrderModal()
        })
      }
    },
    phoneMask() {
      const x = this.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

      this.phone = !x[2]
        ? x[1]
        : '(' +
          x[1] +
          ') ' +
          x[2] +
          (x[3] ? '-' + x[3] : '') +
          (x[4] ? '-' + x[4] : '')
      this.$v.phone.$touch()
    },
    onClose() {
      this.setQuickOrderModal()
    },
    ...mapMutations(['setQuickOrderModal']),
    ...mapActions(['submitQuickOrder']),
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
    },
    phone: {
      required,
      alpha: helpers.regex(
        'alpha',
        /\((0)(\d)(\d)\)\s(\d)(\d)(\d)(-)(\d)(\d)(-)(\d)(\d)/i
      ),
    },
  },
}
</script>

<style>
#modal-quickorder {
  left: 0;
  top: 50%;
  width: 25vw;
  right: 0;
  margin: 0 auto;
  transform: translateY(-50%);
}
@media only screen and (max-width: 768px) {
  #modal-quickorder {
    width: 80% !important;
  }
}
</style>
